import { Action, createReducer, on } from '@ngrx/store';
import { UserGroup, UserGroupsReducer } from '../user-groups.model';
import * as userGroupsActions from './user-groups.action';

const initialState: UserGroupsReducer = {
  userGroups: [],
  userIds: [],
};

function getUpdatedState(userGroups: UserGroup[]) {
  const userIds = [...new Set(userGroups.flatMap((group: UserGroup) => group.mac_ip_bind_ids))];
  return { userGroups, userIds };
}

const reducer = createReducer(
  initialState,

  on(userGroupsActions.setUserGroups, (state, props) => ({
    ...state,
    ...getUpdatedState(props.userGroups),
  })),

  on(userGroupsActions.addUserGroup, (state, props) => {
    const updatedUserGroups = [...state.userGroups, props.userGroup];
    return {
      ...state,
      ...getUpdatedState(updatedUserGroups),
    };
  }),

  on(userGroupsActions.updateUserGroup, (state, props) => {
    const updatedUserGroups = state.userGroups.map((userGroup) =>
      userGroup.id === props.userGroup.id ? { ...props.userGroup } : userGroup
    );
    return {
      ...state,
      ...getUpdatedState(updatedUserGroups),
    };
  }),

  on(userGroupsActions.deleteUserGroups, (state, props) => {
    const updatedUserGroups = state.userGroups.filter(
      (userGroup) => !props.ids.includes(userGroup.id)
    );
    return {
      ...state,
      ...getUpdatedState(updatedUserGroups),
    };
  }),

  on(userGroupsActions.clearUserGroups, () => ({
    ...initialState,
  }))
);

export function userGroupsReducer(state: UserGroupsReducer | undefined, action: Action) {
  return reducer(state, action);
}
